import { render, staticRenderFns } from "./Stackable.vue?vue&type=template&id=832caae2&"
import script from "./Stackable.vue?vue&type=script&lang=js&"
export * from "./Stackable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports